import { PaymentOrderView } from '../types';

export const formatAmount = (amount: number): string => amount.toLocaleString('ko-KR');

export const recipientSummary = (recipient: PaymentOrderView['recipient']): string =>
    `${recipient.name} ${recipient.roleLabel}`;
